const documentTypes = [
  'FS240',
  'DS1350',
  'AlienRegistration',
  'PermanentResident',
  'CertificateOfNaturalization',
  'DerivedAlienRegistration',
  'DerivedPermanentResident',
  'DerivedCertificateOfNaturalization',
  'I-551',
  'I-766',
  'I-94',
  'Visa',
  'NonImmigrantStudent',
  'ExchangeVisitor',
  'Other',
];

// PVQ Dropdown values
export const citizenshipBornAbroadDocumentOptions = [
  'Form FS-240 (Consular Report of Birth Abroad)',
  'Form DS-1350 (Certificate of Report of Birth)',
  'Form FS-545 (Certificate of Birth Abroad)',
  'Form N-560 or Form N-561 (Certificate of Citizenship)',
  'Other',
];

export default documentTypes;
